// App Users translations for React Admin resource
export const appUsersResource = {
  name: 'App Users',
  fields: {
    id: 'ID',
    authId: 'Auth ID',
    email: 'Email',
    phone: 'Phone',
    firstName: 'First Name',
    lastName: 'Last Name',
    name: 'Name',
    vehicleMake: 'Vehicle Make',
    vehicleModel: 'Vehicle Model',
    carPlate: 'License Plate',
    vehicle: 'Vehicle',
    language: 'Language',
    isActive: 'Active',
    isVerified: 'Verified',
    verified: 'Verification',
    wallet: 'Wallet',
    walletBalance: 'Wallet Balance',
    walletCurrency: 'Currency',
    lastSeenAt: 'Last Seen',
    lastUpdatedBy: 'Last Updated By',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  },
  noVehicle: 'No vehicle',
  list: {
    title: 'App Users',
    subtitle: 'Manage mobile app users',
    filters: {
      search: 'Search by phone, name, or license plate',
      activeOnly: 'Active Users Only',
      verifiedOnly: 'Verified Users Only',
      language: 'Language',
    },
    empty: {
      title: 'No app users found',
      subtitle: 'App users will appear here when they register through the mobile app.',
    },
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    verified: 'Verified',
    unverified: 'Unverified',
  },
  edit: {
    title: 'Edit App User',
    subtitle: 'Update user information',
    basicInfo: 'Basic Information',
    vehicleInfo: 'Vehicle Information',
    accountSettings: 'Account Settings',
    walletInfo: 'Wallet Information',
    notificationPreferences: 'Notification Preferences',
    activityInfo: 'Activity Information',
    activeAccount: 'Active Account',
    emailHelperText: 'Changes will be synced to both authentication and profile systems',
    phoneHelperText: 'Primary contact phone number',
    accountWarning: 'Deactivating an account will prevent the user from accessing the app',
    walletReadOnly: 'Wallet balance can only be changed through transactions',
    backToList: 'Back to List',
    phoneCannotEdit: 'Phone number cannot be changed. Users must verify new phone numbers through the app.',
  },
  create: {
    title: 'Create App User',
    subtitle: 'Register a new mobile app user',
    infoMessage: 'Creating an app user manually. They will be able to log in using their phone number.',
    basicInfo: 'Basic Information',
    vehicleInfo: 'Vehicle Information',
    accountSettings: 'Account Settings',
    notificationPreferences: 'Notification Preferences',
    phoneHelperText: 'This will be the user\'s primary login identifier',
    phoneCannotEdit: 'Phone number cannot be changed. Users must verify new phone numbers through the app.',
    vehicleMakeHelperText: 'Select the vehicle manufacturer',
    vehicleModelHelperText: 'Enter the vehicle model (e.g., Model 3, e-tron)',
    carPlateHelperText: 'Vehicle license plate number',
    walletInfo: 'Wallet Information',
    walletHelperText: 'A wallet will be automatically created with zero balance. Users can add funds through the app.',
    notificationPreferencesHelperText: 'Default notification settings for this user',
    phoneValidation: {
      format: 'Please enter a valid phone number',
    },
  },
  notifications: {
    chargingComplete: 'Charging Complete',
    chargingInterrupted: 'Charging Interrupted',
    promotions: 'Promotions & Offers',
    systemUpdates: 'System Updates',
    createSuccess: 'App user created successfully',
    updateSuccess: 'App user updated successfully',
  },
  show: {
    subtitle: 'View user details',
  },
  groupsPanel: {
    title: 'Groups',
    empty: 'Not in any groups',
    selectPlaceholder: 'Select groups...',
    noOptions: 'No groups found',
    noGroupsExist: 'No user groups have been created yet.',
    manageGroups: 'Manage user groups',
    save: 'Save groups',
    saved: 'Groups saved',
  },
};

export const appUsers = {
  'app-users': appUsersResource,
};